import React, { ButtonHTMLAttributes } from "react";
import { Loading } from "../loading";
// import { Icon } from "../sidebar/styles";
import { Container } from "./styles";

interface IconTypeProps {
	width?: number;
	height?: number;
	color?: string;
	backgroundColor?: string;
}

type IconType = (props: IconTypeProps) => JSX.Element;

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	title: string;
	Icon?: IconType;
	handleFunction?: () => void;
	color?: string;
	isLoading?: boolean;
	backgroundColor?: string;
	height?: string;
	rounded?: string;
	fontSize?: string;
}

export const Button: React.FC<Props> = ({
	Icon,
	type = "button",
	title,
	color,
	backgroundColor,
	handleFunction,
	isLoading,
	height = "h-[40px]",
	rounded = "rounded-[4px]",
	fontSize = "text-[14px]",
}) => {
	return (
		<Container
			className={`${height} ${rounded} ${fontSize} `}
			type={type}
			onClick={handleFunction}
			color={color}
			disabled={isLoading}
			backgroundColor={backgroundColor}
		>
			{Icon && <Icon />}
			{isLoading ? <Loading isLoading={isLoading} /> : null}
			<p>{title}</p>
		</Container>
	);
};
